// extracted by mini-css-extract-plugin
module.exports = {"viewButton":"SupportTickets_viewButton__36AXz"};